// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

// Replace this with YOUR actual config from the Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyCZs3jFQvfseoNgT4U-fQMqnzvYR9vcHGE",
  authDomain: "rf-sensing.firebaseapp.com",
  databaseURL: "https://rf-sensing-default-rtdb.firebaseio.com",
  projectId: "rf-sensing",
  storageBucket: "rf-sensing.firebasestorage.app",
  messagingSenderId: "519993780582",
  appId: "1:519993780582:web:768eacc2a3ea2b2f4100a7",
  measurementId: "G-18S63PFSWE"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);